import type { DepositBankAccount } from 'types/BankAccountsDetails'
import { LedgerWalletType, type PaymentInstrument } from 'types/customers'

export const mapPaymentInstrumentToDepositBankAccount = (
  instrument: PaymentInstrument,
  currency?: string
): DepositBankAccount => {
  const nid = instrument?.bankDetails?.nid
  const bankAddress = instrument?.bankDetails?.address
  const accountHolderAddress = instrument?.accountHolderAddress
  const isSwift = !!instrument?.bankDetails?.bic
  const remittancePrefix =
    instrument?.remittanceInformationPrefix || instrument?.paymentReferenceRequiredPrefix

  return {
    currency,
    accountHolderName: instrument?.accountHolderName,
    accountNumber: instrument?.accountNumber,
    bankCode: isSwift ? instrument?.bankDetails?.bic : nid?.value,
    bankName: instrument?.bankDetails?.name,
    reference: remittancePrefix,
    isSwift,
    usdBankRoutingNumber: isSwift ? undefined : nid?.value,
    nid: nid ? { type: nid.type, value: nid.value } : undefined,
    beneficiaryAddress: accountHolderAddress
      ? {
          addressLine1: accountHolderAddress.addressLine1,
          addressLine2: accountHolderAddress.addressLine2,
          city: accountHolderAddress.city,
          countryCode: accountHolderAddress.country,
          postCode: accountHolderAddress.postCode,
        }
      : undefined,
    bankAddress: bankAddress
      ? {
          addressLine1: bankAddress.addressLine1,
          addressLine2: bankAddress.addressLine2,
          city: bankAddress.city,
          countryCode: bankAddress.country,
          postCode: bankAddress.postCode,
        }
      : undefined,
    bankCity: bankAddress?.city,
    bankState: bankAddress?.stateCode,
    bankCountry: bankAddress?.country,
    bankPostalCode: bankAddress?.postCode,
    metaData: undefined,
  }
}

export const mapPaymentInstrumentsToDepositBankAccounts = (
  paymentInstruments: PaymentInstrument[] | undefined,
  currency?: string
): DepositBankAccount[] => {
  const fiatInstruments =
    paymentInstruments?.filter(instrument => instrument.type === LedgerWalletType.FIAT) ?? []
  return fiatInstruments.map(instrument =>
    mapPaymentInstrumentToDepositBankAccount(instrument, currency)
  )
}
